import { Component } from '@angular/core';
import { TermsBaseComponent } from '@src/base-components/terms/terms-base.component';
import { ConfigService } from '@src/services/layout/config.service';

@Component({
    selector: 'app-page-terms',
    templateUrl: '../../../base-components/terms/terms-base.component.html',
    styleUrls: ['../../../base-components/terms/terms-base.component.scss']
})
export class TermsComponent extends  TermsBaseComponent {
    constructor(configService: ConfigService) {
        const params = {
            appName: 'eWarranty',
            companyName: 'Bell and Ross',
            products: 'watches',
            logo : 'assets/default/bellross-full-logo.png',
            ContactEmail : 'warranty@bellross.com'
        };
        const logoUrl = params.logo;
        super(params, logoUrl, configService);
    }
}